import PT from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Pill from '~/components/Workflow/shared/Pill';
import { useIntl } from 'react-intl';
import { getConditionById } from '~/reducers/workflow';
import { testInvalidConditionRule } from '~/utils/workflow';

function ConditionRulePill({
  conditionRule,
  // connected,
  condition,
  isInvalid,
}) {
  const intl = useIntl();
  if (!conditionRule) {
    return null;
  }

  let bg;
  let color;
  let icon = 'condition';
  let text;

  if (conditionRule && condition) {
    bg = 'plum-500';
    color = 'white';
    text = conditionRule.satisfiedWhenCondMet
      ? intl.formatMessage(
          {
            id: 'ConditionRulePill.showIfCondition.true',
            defaultMessage: 'Show if "{conditionName}" is true',
            description:
              'Condition rule description. Example: conditionName = "Field Required"',
          },
          {
            conditionName: condition.name,
          },
        )
      : intl.formatMessage(
          {
            id: 'ConditionRulePill.showIfCondition.false',
            defaultMessage: 'Show if "{conditionName}" is false',
            description:
              'Condition rule description. Example: conditionName = "Field Required"',
          },
          { conditionName: condition.name },
        );
  }

  if (isInvalid) {
    bg = 'red-600';
    icon = 'warning';
    color = 'white';
    text = intl.formatMessage({
      id: 'ConditionRulePill.missingCondition',
      defaultMessage: 'Missing Condition',
      description: 'Text for missing condition pill',
    });
  }

  return <Pill bg={bg} color={color} icon={icon} text={text} />;
}

const conditionRulePropTypes = PT.shape({
  id: PT.string,
  enabledWhenSatisified: PT.bool,
  satisfiedWhenCondMet: PT.bool,
});

ConditionRulePill.propTypes = {
  conditionRule: conditionRulePropTypes,
};

const mapStateToProps = ({ workflow }, { conditionRule }) => ({
  condition: getConditionById(workflow, conditionRule?.id),
  isInvalid: testInvalidConditionRule(conditionRule, workflow.conditions),
});

export default connect(mapStateToProps)(ConditionRulePill);
